import React from "react";

interface RoleOptionProps {
  value: string;
  label: string;
  description: string;
  icon: React.ReactNode;
  selected: boolean;
  onSelect: () => void;
}

const RoleOption: React.FC<RoleOptionProps> = ({
  label,
  description,
  icon,
  selected,
  onSelect,
}) => (
  <button
    type="button"
    onClick={onSelect}
    className={`flex items-center gap-3 w-full px-4 py-3 rounded-xl border text-left
      transition-all duration-150
      ${
        selected
          ? "border-[#0F52BA] bg-blue-50/60 shadow-sm"
          : "border-slate-200 bg-white hover:border-slate-300 hover:bg-slate-50"
      }`}
  >
    <div
      className={`w-8 h-8 rounded-lg flex items-center justify-center flex-shrink-0 transition-colors
      ${
        selected
          ? "bg-[#0F52BA] text-white"
          : "bg-slate-100 text-slate-400"
      }`}
    >
      {icon}
    </div>
    <div className="min-w-0">
      <p
        className={`text-xs font-bold leading-tight ${
          selected ? "text-[#0F52BA]" : "text-slate-700"
        }`}
      >
        {label}
      </p>
      <p className="text-[11px] text-slate-400 mt-0.5">
        {description}
      </p>
    </div>
    <div
      className={`ml-auto w-4 h-4 rounded-full border-2 flex-shrink-0 flex items-center justify-center transition-all
      ${
        selected
          ? "border-[#0F52BA] bg-[#0F52BA]"
          : "border-slate-300"
      }`}
    >
      {selected && <div className="w-1.5 h-1.5 rounded-full bg-white" />}
    </div>
  </button>
);

export default RoleOption;